import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: { xs: "60%", sm: "50%" },
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "342px" },
  bgcolor: "#fff",
  p: 1,
  borderRadius: "4px",
  border: "none",
  height: "140px",
  textAlign: "center",
};

const Uploadfile = ({ isOpen, setisOpen, handleupload }) => {
  const { t } = useTranslation();
  const [xlfile, setxlfile] = useState();

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => setisOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          backgroundColor: "rgb(0, 0, 0, 0.55)",
        }}
      >
        <Box sx={style}>
          <h2 className="kyctitle">{t("upload")}</h2>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => setxlfile(e.target.files[0])}
            className="uploadfile"
          />
          <div className="kycbuttons">
            <button onClick={() => handleupload(xlfile)}>{t("save")}</button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Uploadfile;
